import * as React from 'react';
import { UitkDateNumber } from '../ToolkitComponents/uitk-date-number.esm.js';

var DefaultDayTemplate = function (props) {
    var _a = props.day, isPast = _a.isPast, isToday = _a.isToday, dateDay = _a.day;
    var getTheme = function () {
        if (isToday) {
            return 'today';
        }
        if (isPast) {
            return 'muted';
        }
        return 'default';
    };
    return (React.createElement(UitkDateNumber, { theme: getTheme(), disabled: isPast }, dateDay));
};
DefaultDayTemplate.canClick = function (_dayData, day) { return !day.isPast; };
DefaultDayTemplate.canSpan = function (_dayData, day) { return !day.isPast; };
DefaultDayTemplate.getAriaLabel = function (_dayData, day, l10n) {
    var isPast = day.isPast, localeDateString = day.localeDateString;
    return isPast ? l10n.formatText('calendar.unavailable.a11yLabel', localeDateString) : localeDateString;
};

export { DefaultDayTemplate };
